module.exports = __webpack_public_path__ + "static/media/close.cca8080b.svg";